<script>
export default {
  computed: {
    current () {
      return this.$route.params.bdId
    },
    bdList () {
      return this.docs.bd
    }
  }
}
</script>

<template>
  <div class="gp-bd">
    <div class="page-background"></div>
    <header>
      <h1 class="page-title">Blu-ray</h1>
    </header>
    <div class="bd-index">
      <ul class="level is-mobile">
        <li
          v-for="(bd, bdId) in bdList"
          :key="bdId"
          :class="{current: current === bdId}"
        >
          <router-link :to="{name: 'bd', params: {bdId}}">
            <span class="has-text-weight-bold is-family-oswald is-size-1 is-size-2-mobile">{{ bd.index }}</span>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="transition-container">
      <transition name="slide-in">
        <router-view :key="$route.path"></router-view>
      </transition>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gp-bd {
  .bd-index {
    @include is-not-mobile {
      margin: auto;
      margin-bottom: 3.5rem;
      max-width: 60rem;
      width: calc(100% - 6rem);
    }
    @include is-mobile {
      margin: 2.5rem 1rem;
      margin-bottom: 1rem;
    }
    ul {
      flex-wrap: wrap;
      justify-content: flex-start;
      li {
        @include is-mobile {
          width: calc(50% - .5rem);
          margin-bottom: .5rem;
          &:not(:nth-child(2n)) {
            margin-right: 1rem;
          }
        }
        @include is-not-mobile {
          width: calc(33.33% - 11px);
          margin-bottom: 1rem;
          &:not(:nth-child(3n)) {
            margin-right: 1rem;
          }
        }
        border: 2px solid $black;
        span {
          display: flex;
          align-items: center;
          justify-content: center;
          height:  3.5rem;
          color: $black;
          @include is-mobile {
            height: 2.5rem;
            white-space: nowrap;
          }
        }
        &.current,
        &:hover {
          background-color: $black;
          span {
            color: $yellow;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/bd/bd.vue